import script from "./VariantListView.vue?vue&type=script&setup=true&lang=js"
export * from "./VariantListView.vue?vue&type=script&setup=true&lang=js"

import "./VariantListView.vue?vue&type=style&index=0&id=768bb868&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-768bb868"]])

export default __exports__